import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
export const useMediaQuery = mediaQuery => {
  const [matches, setMatches] = useState(
    () => window.matchMedia(mediaQuery).matches,
  );
  useLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery);
    const listener = e => setMatches(e.matches);
    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [mediaQuery]);

  return matches;
};
export const sleep = (ms = 1000) => new Promise(res => setTimeout(res, ms));
export const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  );
export const pause = () => sleep(0);
export const unwrap_arr = arg => (Array.isArray(arg) ? arg[0] : arg);
export const round_to = (n, precision) =>
  Math.round(n * 10 ** precision) / 10 ** precision;

export const flat = arr => arr.reduce((acc, it) => [...acc, ...it], []);

export function fill_placeholders(arr, count, start = false) {
  // if (!element) {
  //   element = start ? arr[0] : arr[arr.length - 1];
  // }

  let placeholders = new Array(Math.abs(count))
    .fill({ value: 0, label: 'placeholder' })
    .map((e, index) =>
      e.label !== 'placeholder'
        ? { ...e }
        : { ...e, id: (index + 1) * Math.random() },
    );

  let payload = start ? placeholders.concat(arr) : arr.concat(placeholders);
  return payload;
}

export const useClickOutside = callback => {
  const container = useRef(null);
  const [isTouchEvent, setTouchEvent] = useState(false);
  const eventType = isTouchEvent ? 'touchend' : 'click';

  function handleEvent(e) {
    if (e.type === 'click' && isTouchEvent) { return; } // prettier-ignore

    if (container.current && e.target !== null) {
      if (!container.current.contains(e.target)) {
        callback(e);
      }
    }
  }

  useEffect(() => {
    document.addEventListener(eventType, handleEvent, true);

    return () => {
      document.removeEventListener(eventType, handleEvent, true);
    };
  });

  useEffect(() => {
    setTouchEvent('ontouchstart' in document.documentElement);
  }, []);

  return container;
};

export function useHover() {
  const [value, setValue] = useState(false);

  const ref = useRef(null);

  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);

  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        node.addEventListener('mouseover', handleMouseOver);
        node.addEventListener('mouseout', handleMouseOut);

        return () => {
          node.removeEventListener('mouseover', handleMouseOver);
          node.removeEventListener('mouseout', handleMouseOut);
        };
      }
    },
    [ref.current], // Recall only if ref changes
  );

  return [ref, value];
}
